export default "/images/vendor/trumbowyg/dist/ui/icons.svg?053f5c84b2e73dfc653cb91939b5b922";